import React, { Component } from 'react';
import _ from 'lodash';
import TagCloud from 'react-tag-cloud';
import randomColor from 'randomcolor';
import { updateTagId, projectListingGrid } from "../../actions/DashboardAction";
import { connect } from 'react-redux';
import {getFontClass} from "../../actions/Common";

class DefaultWordCloud extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tagStyle : {},
            tagPadding: 10
        };
    }

    componentDidMount(){
        this.addMasonry()
    }

    /**
     * Just for testing the click even. This will be use for project link
     */
    clickMe = (tagId, tagName) => {
        if(this.props.platform == 'mobile') {
            window.postMessage(tagId, "*");
        } else {
            this.props.onClick(tagId, tagName);
        }
    };

    addMasonry = () => {
        setTimeout(function () {


        $(function() {
            jQuery('#tags-area .item').each(function(){
                var elem = jQuery(this);
                let h = elem.find('span').height();
                let w = elem.find('span').width();
                elem.attr('data-heightn',h);
                elem.attr('data-widthn',w);
                console.log({
                    'h': h,
                    'w': w
                })
                if(elem.hasClass('vm')){

                    elem.css({'min-height':elem.data('widthn'), 'max-height':elem.data('widthn')});
                    elem.css({'min-width':elem.data('heightn'), 'max-width':elem.data('heightn')});
                    elem.find('span').css({
                        'position':'absolute',
                        'min-height':elem.data('heightn'),
                        'min-width':elem.data('widthn'),
                        'top':(elem.data('widthn') / 2) +'px' ,
                        'right':(elem.data('heightn') / 2) +'px',
                    });
                } else {
                    elem.css({'min-height':elem.data('heightn'), 'max-height':elem.data('heightn')});
                    elem.css({'min-width':elem.data('widthn'), 'max-width':elem.data('widthn')});
                }
            });

            jQuery('#tags-area').masonry({
                itemSelector: '.item',
                gutter: 0,
                percentPosition: false
            });
        });
        }, 100)
    }

    /**
     * Create tag
     * @param tag
     * @param colorClass
     * @param order
     * @param isVertical
     * @returns {*}
     */
    createTag(tag, colorClass, order, isVertical = false) {
        if(tag[order] != undefined) {
            const tagId     = tag[order].tagId;
            const tagName   = tag[order].tagName;
            const tagCount  = tag[order].tagCount;
            const fontClass = getFontClass(order);
            
            return(
                <div key={tagId} className={`item box ${colorClass} ${fontClass} ${isVertical ? 'vm' : ''}`} onClick={() => this.clickMe(tagId, tagName)}>

                   {/*<span>{order == 0 ? "Plastic" : tagName}</span>*/}
                   <span>{tagName}</span>
                </div>
            )
        } else {
            return null
        }
    }

    /**
     * Render the component
     * @returns {*}
     */
    render() {
        const tag = (this.props.tagCloudDetail) ? this.props.tagCloudDetail:[];

        return (
            <div>
                <div className='app-outer'>
                    <div className='app-inner' style={{background: 'white'}}>
                        <div id="tags-area" className="tags-area">
                            {this.createTag(tag, 'color-violet1', 0, true)}
                            {this.createTag(tag, 'color-blue4', 1)}
                            {this.createTag(tag, 'color-green1', 2)}
                            {this.createTag(tag, 'color-blue1', 3)}
                            {this.createTag(tag, 'color-blue5', 4)}
                            {this.createTag(tag, 'color-violet2', 31)}
                            {this.createTag(tag, 'color-blue3', 32)}
                            {this.createTag(tag, 'color-blue6', 8, true)}
                            {this.createTag(tag, 'color-violet1', 33)}
                            {this.createTag(tag, 'color-brown2', 34)}
                            {this.createTag(tag, 'color-brown2', 5)}
                            {this.createTag(tag, 'color-green2', 6)}
                            {this.createTag(tag, 'color-orange1', 11)}
                            {this.createTag(tag, 'color-blue1', 7)}
                            {this.createTag(tag, 'color-gray', 10, true)}
                            {this.createTag(tag, 'color-blue1', 9)}
                            {this.createTag(tag, 'color-orange3', 12)}
                            {this.createTag(tag, 'color-green2', 17)}
                            {this.createTag(tag, 'color-blue6', 18)}
                            {this.createTag(tag, 'color-orange1', 14)}
                            {this.createTag(tag, 'color-orange1', 19)}
                            {this.createTag(tag, 'color-green3', 20)}
                            {this.createTag(tag, 'color-pink', 13, true)}
                            {this.createTag(tag, 'color-pink', 21)}
                            {this.createTag(tag, 'color-green4', 22)}
                            {this.createTag(tag, 'color-pink', 23)}
                            {this.createTag(tag, 'color-green2', 24)}
                            {this.createTag(tag, 'color-orange3', 25)}
                            {this.createTag(tag, 'color-brown1', 26)}
                            {this.createTag(tag, 'color-blue6', 15, true)}
                            {this.createTag(tag, 'color-blue2', 16)}
                            {this.createTag(tag, 'color-green2', 27)}
                            {this.createTag(tag, 'color-green1', 28)}
                            {this.createTag(tag, 'color-orange1', 29)}
                            {this.createTag(tag, 'color-blue3', 30)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(null, {updateTagId, projectListingGrid})(DefaultWordCloud);



// WEBPACK FOOTER //
// ./components/WordCloud/DefaultWordCloud.js